module.exports = __webpack_public_path__ + "img/milestone__1966.9a18ba04.jpg";